import type { ElementType } from 'react'
import { LuKeyRound, LuLayoutDashboard, LuMail, LuMap, LuSettings, LuUserCheck, LuUsers, LuVote } from 'react-icons/lu'

export interface OrgTab {
  key: 'overview' | 'members' | 'review' | 'map' | 'communications' | 'votings' | 'committees' | 'settings'
  label: string
  icon: ElementType
  to: string
}

/**
 * The organization dashboard sections (sidebar + mobile tab strip). The map only exists when locations are collected,
 * the committees tab only when the server has a Council app (publicConfig.councilAppUrl).
 */
export const orgTabs = (
  orgId: string,
  { collectLocation = true, committees = false }: { collectLocation?: boolean; committees?: boolean } = {}
): OrgTab[] => {
  const base = `/organizer/orgs/${orgId}`
  const tabs: OrgTab[] = [
    { key: 'overview', label: 'Overview', icon: LuLayoutDashboard, to: `${base}/overview` },
    { key: 'members', label: 'Members', icon: LuUsers, to: `${base}/members` },
    { key: 'review', label: 'Review queue', icon: LuUserCheck, to: `${base}/review` },
    { key: 'map', label: 'Map', icon: LuMap, to: `${base}/map` },
    { key: 'communications', label: 'Communications', icon: LuMail, to: `${base}/communications` },
    { key: 'votings', label: 'Votings', icon: LuVote, to: `${base}/votings` },
    { key: 'committees', label: 'Committees', icon: LuKeyRound, to: `${base}/committees` },
    { key: 'settings', label: 'Settings', icon: LuSettings, to: `${base}/settings` },
  ]
  return tabs.filter((t) => (t.key !== 'map' || collectLocation) && (t.key !== 'committees' || committees))
}
